/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TCOVehicleDetailsDiesel
 */
export interface TCOVehicleDetailsDiesel {
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    purchaseCost: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    annualTollCost: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    annualInsuranceCost: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    annualOtherCost: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    annualServiceAndMaintenanceCost: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    fuelPrice: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    fuelAverageConsumption: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    gCo2PerUnitProduction: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    residualValue: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    adbluePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof TCOVehicleDetailsDiesel
     */
    adblueAverageConsumption?: number;
}

export function TCOVehicleDetailsDieselFromJSON(json: any): TCOVehicleDetailsDiesel {
    return TCOVehicleDetailsDieselFromJSONTyped(json, false);
}

export function TCOVehicleDetailsDieselFromJSONTyped(json: any, ignoreDiscriminator: boolean): TCOVehicleDetailsDiesel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purchaseCost': json['purchase_cost'],
        'annualTollCost': json['annual_toll_cost'],
        'annualInsuranceCost': json['annual_insurance_cost'],
        'annualOtherCost': json['annual_other_cost'],
        'annualServiceAndMaintenanceCost': json['annual_service_and_maintenance_cost'],
        'fuelPrice': json['fuel_price'],
        'fuelAverageConsumption': json['fuel_average_consumption'],
        'gCo2PerUnitProduction': json['g_co2_per_unit_production'],
        'residualValue': json['residual_value'],
        'adbluePrice': !exists(json, 'adblue_price') ? undefined : json['adblue_price'],
        'adblueAverageConsumption': !exists(json, 'adblue_average_consumption') ? undefined : json['adblue_average_consumption'],
    };
}

export function TCOVehicleDetailsDieselToJSON(value?: TCOVehicleDetailsDiesel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purchase_cost': value.purchaseCost,
        'annual_toll_cost': value.annualTollCost,
        'annual_insurance_cost': value.annualInsuranceCost,
        'annual_other_cost': value.annualOtherCost,
        'annual_service_and_maintenance_cost': value.annualServiceAndMaintenanceCost,
        'fuel_price': value.fuelPrice,
        'fuel_average_consumption': value.fuelAverageConsumption,
        'g_co2_per_unit_production': value.gCo2PerUnitProduction,
        'residual_value': value.residualValue,
        'adblue_price': value.adbluePrice,
        'adblue_average_consumption': value.adblueAverageConsumption,
    };
}


